export type AppBootstrapView = 'loading' | 'error' | 'app';

/**
 * Which top-level view App renders while the courier bootstrap is in flight.
 *
 * Only the *first* load may replace the router: fetchCourier is also used as a
 * refresh (onboarding Stripe return, Billing plan changes), and swapping the
 * router out then unmounts the very page that asked for it — users saw that as
 * the page reloading itself mid-onboarding.
 */
export const getAppBootstrapView = ({
  isLoading,
  hasCourier,
  hasError,
}: {
  isLoading: boolean;
  hasCourier: boolean;
  hasError: boolean;
}): AppBootstrapView => {
  if (hasCourier) return 'app';
  if (isLoading) return 'loading';
  if (hasError) return 'error';
  return 'app';
};
